/* eslint-disable import/no-anonymous-default-export */
import config from '../../../_config/global';
import {
  IDeleteSingleArgs,
  IGetSingleArgs,
  IPageAndSearchArgs,
  IUpdateSingleArgs
} from '../../../interfaces';
import { goFetch } from '../../../utilities/goFetch';

interface apiResponse {
  data: Object;
  message: string;
  success: boolean;
}

class Service {
  async getByPage({ search, pageNo }: IPageAndSearchArgs) {
    const banks = (await goFetch(config.endpoints.banks.getByPage)
      .withQueryParameters({
        search: search ?? '',
        pageSize: config.pageSize,
        pageNumber: pageNo || 1
      })
      .get()) as any;
    const { paginatedResults, totalCount } = banks?.data[0] || {};
    const itemCount = totalCount?.[0]?.count || 0;
    return {
      pageNo: pageNo,
      pageSize: config.pageSize,
      pageCount: Math.ceil(itemCount / config.pageSize),
      data: paginatedResults,
      itemCount
    };
  }

  async getSingle({ key }: IGetSingleArgs) {
    const bankSingle = (await goFetch(`${config.endpoints.banks.getSingle}`)
      .withQueryParameters({ id: key })
      .get()) as unknown as apiResponse;
    return bankSingle.data;
  }

  async create() {
    return (await goFetch(
      `${config.endpoints.banks.add}`
    ).put()) as unknown as apiResponse;
  }

  async update({ key, ...rest }: IUpdateSingleArgs) {
    await goFetch(`${config.endpoints.banks.update}`)
      .withBody({
        _id: key,
        ...rest
      })
      .post();
  }

  async delete(key: IDeleteSingleArgs) {
    await goFetch(`${config.endpoints.banks.delete}`)
      .withBody({ _id: key })
      .delete();
  }
}

export default new Service();
